import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4e863bbc&"
import script from "./edit?vue&type=script&lang=js&"
export * from "./edit?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports